module.exports = __webpack_public_path__ + "static/media/revisionIcon.13623d19.svg";